import { type ObjectTreeItemType, useObjectTree } from '@/entities/ObjectsTree'
import { useHelpers, useTranslate } from '@/shared/lib'
import { useTreeDelete } from './../model/api'
import { useNotification } from '@/shared/ui'
import { size } from 'lodash'

export const useModel = () => {
  const tree = useObjectTree()
  const { removeTreeElementById } = useHelpers()
  const { remove } = useTreeDelete()
  const { addError } = useNotification()
  const { trs } = useTranslate()

  /**
   * Функция удаления объекта
   */
  const removeObject = async (objects: ObjectTreeItemType[]) => {
    if (objects.some((item: ObjectTreeItemType) => size(item.child_count))) {
      addError(trs('itf.not_removed'))
    } else {
      for (let i = 0; i < objects.length; i++) {
        await remove(objects[i].id)

        removeTreeElementById(tree.objects, objects[i].id)
      }
    }

    tree.contextObject = null
  }

  return {
    removeObject,
  }
}
